export default __webpack_public_path__ + "static/media/representatives_left_bg.f84f97a9.svg";